import { render } from "./SignalText.vue?vue&type=template&id=32773da2&ts=true"
import script from "./SignalText.vue?vue&type=script&lang=ts"
export * from "./SignalText.vue?vue&type=script&lang=ts"

import "./SignalText.vue?vue&type=style&index=0&id=32773da2&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__